/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const CodeView = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="m16.95 8.46 1.41-1.41L23.31 12l-4.95 4.95-1.41-1.41L20.49 12zm-9.9 0L3.51 12l3.54 3.54-1.41 1.41L.69 12l4.95-4.95z" />
  </Icon>
);
